import { gql } from "apollo-angular";

// Requisição de Filtrar comandos (Tela de comandos)
const COMMAND_BULK_REQUESTS = gql`
query CommandBulkRequests(
	$company: ID!
	$commandType: String
	$first: Int
	$last: Int
	$customBefore: String
	$customAfter: String
	$sort_field: CommandBulkRequestOrderingFields!
	$sort_dir: CommandBulkDirection!
	$total: Boolean
) {
	commandBulkRequests(
		company: $company
		commandType: $commandType
		first: $first
		last: $last
		customBefore: $customBefore
		customAfter: $customAfter
		orderBy: { direction: $sort_dir, field: $sort_field }
		total: $total
	) {
		edges {
			node {
				id
				type
				requestDt
				parameter
				value
				channel
				dimming
				queryType
				scheduleSlot
				switchOnTime
				switchOffTime
				commands
				user {
					firstName
					lastName
				}
			}
			cursor
		}
		total
		count
		pageInfo {
			hasNextPage
			hasPreviousPage
			startCursor
			endCursor
		}
	}
}`;

// 	Requisição de filtrar comandos por mac adress (no mapa)
const GET_COMMAND_BULK_REQUESTS_MAC_ADDRESS = gql`
query commandBulkRequestsMacAddress(
	$macAddress: String!
	$company: ID!
	$first: Int
	$last: Int
	$before: String
	$after: String
	$sort_field: CommandBulkRequestOrderingFields!,
 	$sort_dir: CommandBulkDirection!
){
  commandBulkRequestsMacAddress(
    macAddress: $macAddress,
    company: $company,
    first: $first,
	last: $last,
	before: $before,
	after: $after,
    orderBy: {direction: $sort_dir, field: $sort_field}

  ) {
    edges {
            cursor
            node {
				id
				type
				requestDt
				parameter
				value
				channel
				dimming
				queryType
				scheduleSlot
				switchOnTime
				switchOffTime
				commands
				user {
					firstName
					lastName
				}
			}
    }
    pageInfo {
       hasNextPage
		hasPreviousPage
		startCursor
		endCursor
    }

  }
}

`;

const SEND_QUERY_COMMAND = gql`
mutation SendQueryCommand(
	$devices: [String]!
	$type: QueryCommandType!
	$requestDt: DateTime!
) {
	sendQueryCommand(
		input: { deviceMacs: $devices, type: $type, requestDt: $requestDt }
	) {
		commandBulkRequest {
			id
			commands
		}
	}
}`;

// requisição usada para fazer consultas de agendamentos ativos (tela de comandos)
const SEND_QUERY_SCHEDULE_COMMAND = gql`
mutation SendQueryScheduleCommand(
	$devices: [String]!
	$requestDt: DateTime!
	$scheduleSlot: Int!
) {
	sendQueryScheduleCommand(
		input: {
			deviceMacs: $devices
			requestDt: $requestDt
			scheduleSlot: $scheduleSlot
		}
	) {
		commandBulkRequest {
			id
			type
			user {
				username
			}
			commands
		}
	}
}`;

// Mutation para desativar um equipamento por comando (Tela de comandos)
const SEND_SWITCH_ON_COMMAND = gql`
mutation sendSwitchOnCommand($devices: [String]!, $requestDt: DateTime!) {
	sendSwitchOnCommand(input: { deviceMacs: $devices, requestDt: $requestDt }) {
		commandBulkRequest {
			id
			commands
		}
	}
}`;

// Mutation para desativar equipamentos através de comando (Tela de comandos)
const SEND_SWITCH_OFF_COMMAND = gql`
mutation sendSwitchOffCommand($devices: [String]!, $requestDt: DateTime!) {
	sendSwitchOffCommand(input: { deviceMacs: $devices, requestDt: $requestDt }) {
		commandBulkRequest {
			id
			commands
		}
	}
}`;

// Mutation para enviar um novo comando para equipamentos (tela de comandos)
const SEND_SET_PARAMETER_COMMAND = gql`
mutation SendSetParameterCommand(
	$devices: [String]!
	$parameter: String!
	$requestDt: DateTime!
	$value: GenericScalar!
) {
	sendSetParameterCommand(
		input: {
			deviceMacs: $devices
			parameter: $parameter
			value: $value
			requestDt: $requestDt
		}
	) {
		commandBulkRequest {
			id
			commands
		}
	}
}`;

export {
	// Queries
	COMMAND_BULK_REQUESTS,
	GET_COMMAND_BULK_REQUESTS_MAC_ADDRESS,
	// Mutations
	SEND_QUERY_COMMAND,
	SEND_SWITCH_ON_COMMAND,
	SEND_SWITCH_OFF_COMMAND,
	SEND_SET_PARAMETER_COMMAND,
	SEND_QUERY_SCHEDULE_COMMAND
};